import { backgroundTernaryColor, tableHeaderColor, tableRowBorderHover } from "../palette";

export const MuiTable = {
  MuiTableHead: {
    root: {
      backgroundColor: tableHeaderColor,
    },
  },
  MuiTableCell: {
    root: {
      borderBottom: "none",
    },
  },
  MuiTableRow: {
    head: {
      backgroundColor: tableHeaderColor + "!important",
      border: "none",
      "&:hover": {
        border: "none",
        backgroundColor: tableHeaderColor + "!important",
      },
    },
    root: {
      // added new hover color
      border: "1px solid transparent",
      borderBottom: "none",
      "&:hover": {
        backgroundColor: backgroundTernaryColor + "!important",
      },
      // "&:nth-of-type(odd)": {
      //   backgroundColor: backgroundTernaryColor,
      // },
    },
  },
};
